import { render, staticRenderFns } from "./mapping.vue?vue&type=template&id=f539aa42&scoped=true&lang=pug&functional=true"
import script from "./mapping.vue?vue&type=script&lang=js"
export * from "./mapping.vue?vue&type=script&lang=js"
import style0 from "./mapping.vue?vue&type=style&index=0&id=f539aa42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "f539aa42",
  null
  
)

export default component.exports